module.exports = __webpack_public_path__ + "img/Ken_Truitt.87436f0f.png";